import validate from "/www/wwwroot/m.ichi-cake.com/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.14.0_db0@0.3.1_eslint@9.24.0_jiti@2.4._09a1e463bc21da7540347d1570734a24/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/www/wwwroot/m.ichi-cake.com/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.14.0_db0@0.3.1_eslint@9.24.0_jiti@2.4._09a1e463bc21da7540347d1570734a24/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/www/wwwroot/m.ichi-cake.com/middleware/auth.ts")
}